import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { AreaCategory, CardioOrResistance, WorkoutSettings } from 'fitbeat.gym-core';
import theme from '../../theme';
import { defaultScale, scaleText } from '../../utils/scaling';
import { SelectionContainer } from './SelectionContainer';
import { mappedWorkoutType } from './WorkoutTypeSelection';

const tileHeight = defaultScale(100);
const tileWidth = defaultScale(100);

interface IState {
  cardioOrResistance: CardioOrResistance;
}

interface IProps {
  workoutSettings: WorkoutSettings;
  areaCategory?: AreaCategory;
  workoutTypeSelected(cardioOrResistance: CardioOrResistance): void;
}
export class TypeOfWorkout extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    const { workoutSettings } = this.props;

    this.state = {
      cardioOrResistance: workoutSettings.cardioOrResistance,
    };
  }

  public render() {
    const { workoutTypeSelected, areaCategory } = this.props;

    const types = areaCategory === 'boxing'
      ? [
        CardioOrResistance.Cardio,
      ]
      : [
        CardioOrResistance.Cardio,
        CardioOrResistance.Resistance,
        CardioOrResistance.Balance,
      ];
    return (
      <View style={styles.container}>
        {types.map((type) => {
          const isSelected = this.state.cardioOrResistance === type;
          return (
            <SelectionContainer
              key={type}
              width={tileWidth}
              height={tileHeight}
              title={mappedWorkoutType[type].title}
              subTitle={`(${mappedWorkoutType[type].parentheticDescription})`}
              subTitleStyle={{ paddingTop: defaultScale(2) }}
              titleStyle={styles.iconTitle}
              isSelected={isSelected}
              overrideLightStyles={{ defaultBorderColor: theme.DARK_CHARCOAL, borderWidth: 1 }}
              onPress={() => {
                if (this.state.cardioOrResistance === type) {
                  return;
                }
                this.setState({ cardioOrResistance: type });
                workoutTypeSelected(type);
              }}
              icon={(
                <View>
                  {mappedWorkoutType[type].icon(
                    isSelected ? theme.WHITE : theme.BLACK,
                  )}
                </View>
              )}
            />
          );
        })}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  iconTitle: {
    fontFamily: theme.Weight700,
    fontSize: scaleText(18),
    paddingTop: 0,
  },
});
